import { useQuery } from '@tanstack/react-query';

import { IRiskAnalysisGoodsRef } from '@e-origin/shared';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

interface HookProps {
  batchId: string;
}

export const retrieveDeclarationsRefsByImpact = async ({ batchId }: HookProps): Promise<IRiskAnalysisGoodsRef[]> => {
  try {
    const result = await apiClient.declarations.retrieveDeclarationsRefsByImpact.query({ params: { batchId } });
    if (result.status !== 200) throw result.body;

    return result.body.data as IRiskAnalysisGoodsRef[];
  } catch (error) {
    showErrorToast(error, 'Failed to fetch declarations refs');
  }
};

export const useDeclarationsRefsByImpact = ({ batchId }: HookProps) =>
  useQuery({
    queryKey: ['declaration-type', batchId],
    queryFn: async () => retrieveDeclarationsRefsByImpact({ batchId }),
    placeholderData: [],
  });
